import React, { forwardRef } from 'react'

import { BaseButton, type BaseButtonProps } from './BaseButton'

export interface ButtonLinkProps
  extends BaseButtonProps, Omit<
    React.AnchorHTMLAttributes<HTMLAnchorElement>,
    'className'
  > {
  children: React.ReactNode;
  disabled?: boolean;
}

export const ButtonLink = forwardRef<HTMLAnchorElement, ButtonLinkProps>(({
  children,
  ...props
}, forwardedRef) => {
  return (
    <BaseButton {...props}>
      <a
        aria-disabled={props.disabled}
        href={props.disabled ? undefined : props.href}
        onClick={
          props.disabled
            ? (event) => {
                event.preventDefault()
              }
            : props.onClick
        }
        ref={forwardedRef}
        tabIndex={props.disabled ? -1 : undefined}
      >
        {children}
      </a>
    </BaseButton>
  )
})
